<template>
  <div class="uploadVadio">
      <div class="vadioContainer">
          <div class="cityAndname">
             
              <div class="videoName">
                   <p class="leftFonts" style="color:rgba(51,51,51,1);margin-top: 0.18rem;">视频标题</p>
                   <textarea type="text" v-model="vdNmae"  minlength="0" maxlength="20" ref="count"   placeholder="请输入视频标题">
                   </textarea>
              </div>
                <!-- <div class="isCity">
                    <p class="leftFonts">你的家乡</p>
                    <div class="toCity" >
                        <p >{{cityname}}</p>
                        <img src="../../assets/img/wuhanImg/toSelectCity.png" alt=""   @click="toSelectCity" >
                    </div>


                </div>
                <div>
                    <mt-popup v-model="popupVisible" position="bottom">   
                        <div class="pop-btn">
                　　        <p @click="cancel()">取消</p>
                            <p @click="save()">确定</p>
                        </div>
                        <mt-picker :slots="areaList" value-key="name" @change="changeCity"></mt-picker>
                    </mt-popup>
                </div> -->
                <div class="realUpload">
                    <p class="leftFonts">上传视频</p>
                </div>
                <div class="realVideo">
                    <div class="addVideo" @click="uploadVideo">
                        <img src="../../assets/img/wuhanImg/addVideo.png" alt="">
                         <form ref="vExample">
                           <input type="file" id="addVideo-file"   style="display:none;"    @change="vExampleUpload($event)"   accept="video/*" ref="vExampleFile" />
                        </form>
                    </div>
                    <div class="isVideo">
                        <div class="video swiper-no-swiping">
                            
                            <img src="../../assets/img/wuhanImg/quUpload.png" alt="" @click="cancelUpload" class="img1">
                            <!-- <video  controls="controls" id="aa" @canplaythrough="myFunction($event)"  ref="videoDur"></video> -->
                                <div class="swiper-wrapper" style="z-index:3;">
                                    <div id='id_test_video' class="id_test_vide swiper-slide" style="width:4.12rem;height:auto"></div>
                                </div>
                                <!-- <div v-show="broadcasts == '1'" class="cengs" style="width:4.14rem;position:absolute;top:0;left:0;z-index:20;background-size: 100%;border-radius: 0.08rem;">
                                    <img src="../../assets/img/bofang1.png" @click="broadcast()" alt="" style="float:left;z-index: 20;margin:1rem 0 0 2rem; width:0.46rem;">
                                </div> -->
                        </div>
                    </div>
                </div>
                <div class="tipsFonts">
                    <p>为保证视觉效果，建议上传横屏视频</p>
                    <p>视频最大不能超过300M,时长不得超过3分钟</p>
                    <p>已上传视频24小时内审核完成</p>
                </div>
                

              <div class="button1">
                   <div class="red" v-if="vdNmae=='' || isfileId==''">
                    <button class="button22"></button>
                  </div>
                  <div class="red" v-else>
                    <button  @click="addVideo"  class="button11"  :disabled="isDisabled"></button>
                  </div>
                 
              </div>
            
          </div>
      </div>
      <!-- 进度蒙层 -->
      <div class="mark"  v-show="isUpload=='1'">
                <!-- 上传信息组件	 -->
                <div class="uploaderMsgBox" v-for="uploaderInfo in uploaderInfos" :key="uploaderInfo.isVideoUploadCancel">
                    <div v-show="uploaderInfo.videoInfo">
                        <p style="margin-bottom:0.17rem;font-size:0.26rem;font-weight:400;color:rgba(153,153,153,1);"> {{uploaderInfo.isVideoUploadCancel ? '已取消' : uploaderInfo.isVideoUploadSuccess ? '上传成功' : '正在上传中，请稍后'}}</p> 
                        <div class="progressBar" style="margin-bottom:0.17rem;">
                            <div class="fill" ></div>
                        </div>
                    </div>
                </div>
        </div>
        <div class="mark mark1" v-show="gotoLogin">
              <div class="goLogin">
                  <div class="img1">
                     <p class="top">视频上传成功</p>
                     <p class="top2">登录后，可在“我的视频”中查看</p>
                  </div>
                  <p class="fonts"  @click="gotoLoginPage">登录</p>
              </div>


        </div>
        

      
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import { MessageBox } from 'mint-ui';
import { Picker } from 'mint-ui';
import { setTimeout } from 'timers';
import md5 from 'js-md5';
import cbct from '../../assets/js/common/base.js';
import TcVod from 'vod-js-sdk-v6'
import axios from 'axios';
import qs from 'qs';
import share from '../../assets/js/common/share.js';
import shareMsg from '../../assets/js/common/shareConfig.js';

export default {
    name: 'uploadVadio',
    data:function(){
        return{
            cityname:'',//城市名称
            uploaderInfo:[],
            vdNmae:'',
            cityId:'',
            isfileId:'',
            isvideoUrl:'',
            isText:'0',
            isNo:false,
            isdis:false,
            from1:'',
            from2:'',
            isDisabled:false,
            popupVisible:false,//初始选择地区为关闭状态
            flag:false,//初始时禁止picker自动加载
            areaList:[
                {                       //一级   省
                    flex: 1,
                    values: ["请选择"],
                    className: 'slot1',
                    textAlign: 'center'
                }, {
                    divider: true,
                    content: '-',
                    className: 'slot1'
                }, {                    //二级   市
                    flex: 1,
                    values: ["请选择"],
                    className: 'slot1',
                    textAlign: 'center'
                },{
                    divider: true,
                    content: '',
                    className: 'slot1'
                }
            ],
            proviceId:'',//省id
            uploaderInfos: [],//下载文件信息
            isUpload:'',//进度条蒙层
            tempCity:'',
            gotoLogin:false,//去登陆页面
            ncp_id:'',
            isReturn:'',
            handler:function(e){e.preventDefault();},
            //播放按钮展示隐藏
            broadcasts:'1',
            //暂停
            stops:'0',
            //播放器
            player:'',
            //是否音频
            isLiving:'1',
           

        
         
        }
    },
    components: {
      
    },
    methods:{
         // 获取上传视频签名
        getSignature:function(){
            var self=this;
            return axios({
                method:'POST',
                url:this.cbct.https()+'/admin/moment/upload-signature',
                data:qs.stringify({
                    category:'1',
                    ncp:'ncp'
                }),
            headers:{
                'X-cbct-domain':'o',
                'X-cbct-utk':self.cbct.getCookie('token2'),
                'X-cbct-tsm':Number(Date.parse(new Date()))+Number(self.cbct.getCookie('timing')),
                'X-cbct-sgn':md5(Number(Date.parse(new Date()))+Number(self.cbct.getCookie('timing'))+md5(self.cbct.getCookie('token2')+self.cbct.H5key)+self.cbct.getCookie('salt2')),
                'Content-Type':'application/x-www-form-urlencoded',
            }
            }).then((response)=>{
                if(response.data.c ==self.cbct.code.successRes){
                        return response.data.d.signature;
                }else if(response.c ==this.cbct.code.noLogin){
                    
                }else if(response.c ==this.cbct.code.raleNoLogin){
                    
                }else{
                    
                }
            }).catch((error)=>{
                Toast({ 
                    message: '上传失败,请重新上传',
                    position: 'center',
                    duration: 2000
                });
               
                
            })

        },
        // 点击上传视频
        uploadVideo:function(){
            
            var self = this;
            self.uploaderInfos=[];   
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
           
            if (self.from1 == 'app') {
                var obj1={
                "action": "uploadAFile",
                "content": {
                  'actType':'ncp',
                  'size':'524288000',
                  'min_duration':'1000',
                  'max_duration':'180000'
                 }
                }
                var obj2={
                    "action": "onClickPlay",
                    "content": {}
                }
                if (isAndroid) {
                    App.onAppResponse(JSON.stringify(obj1));
                }
                if (isIOS) {
                    self.$refs.vExampleFile.click()
                }
            }else{
                self.$refs.vExampleFile.click();
            }
        },
        // 获取视频时长
        myFunction:function(){
            this.videoDuration=this.$refs.videoDur.duration;
        },
        // 删除已上传的作品
        cancelUpload:function(){
              if(this.player != ''){
                 this.player='';
                 $('.isVideo .swiper-wrapper #id_test_video').remove();
              }
              $('.addVideo').show();
              $('.isVideo').hide();
              this.isfileId='';
              this.isvideoUrl='';
              this.$refs.vExample.reset();
              this.uploaderInfos=[];     
              this.broadcasts='1';
            
        },
           //视频播放
        broadcast:function(){
            // this.broadcasts = '0';
            // this.stops = '0';
            // $('video')[0].play();
            if (this.from1 == 'app') {
                var u = navigator.userAgent, app = navigator.appVersion;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                const win = window;
                var obj={
                    "action": "onClickPlay",
                    "content": {}
                }
                if (isAndroid) {
                    App.onAppResponse(JSON.stringify(obj));
                }
                if (isIOS) {
                    win.webkit.messageHandlers.onAppResponse.postMessage(JSON.stringify(obj));
                }  
           }
        },


        //  上传视频过程
        vExampleUpload: function () {
            var self = this;
            let fileSize=this.$refs.vExampleFile.files[0].size;
            let fileMsg=this.$refs.vExampleFile.files[0];
            var url=URL.createObjectURL(fileMsg);
            if (url!='') {
                var str ='';
                str += '<div id="id_test_video" class="id_test_vide swiper-slide" style="width:4.12rem;height:auto">'
                str += '</div>';
                $('.isVideo .swiper-wrapper #id_test_video').remove();
                $('.isVideo .swiper-wrapper').append(str);
            }
            if(this.player == ''){
                this.player = new TcPlayer('id_test_video', {
                            mp4: url,
                            "autoplay" : false,      //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                            "width" :  '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                            "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                            flashUrl:'//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf',
                            systemFullscreen:true,
                            "wording": {
                                2032: "请求视频失败，请检查网络",
                                2048: "请求m3u8文件失败，可能是网络错误或者跨域问题"
                            },
                            // 'controls':'none',
                            h5_flv:true,
                            poster:self.cbct.imgUrlImg()+self.cbct.getCookie('image'),
                            x5_player:true,
                            x5_type:'h5',
                            x5_fullscreen:'true',


                            flash:true,
                            live:false,
                            x5_orientation:2,
                            listener:function(){
                                // $('video').css('object-fit','fill');
                                var u = navigator.userAgent, app = navigator.appVersion;
                                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                                //解决问题的代码
                                if(isAndroid){
                                    $('video').attr("x5-video-player-type","h5-page");
                                }
                                var heightsss = $('.vcp-timelabel').height();
                                console.log('heightsss',heightsss);
                                $('.vcp-timelabel').css({
                                    'font-size': '0.26rem',
                                    'font-weight': 'normal',
                                    'line-height':heightsss+'px',
                                });  
                                $('.vcp-slider-thumb').css({
                                    'background': 'rgba(204, 50, 50, 1) !important',
                                })
                                $('.vcp-slider-track').css({
                                    'background': 'rgba(204, 50, 50, 1) !important',
                                })
                                
                                $('.vcp-slider').css({
                                    'background': 'rgba(255, 255, 255, 0.3)',
                                })
                                var height222 = (heightsss/2) - 3;
                                console.log('height222',height222)
                                $('.vcp-timeline').css({
                                    'height': '2px',
                                    'margin-left': '49%',
                                    'width': '35%',
                                    'margin-top': height222+'px',
                                    'top':'0',
                                    'left': '0',
                                    'height': '10px',
                                    'position': 'absolute',
                                    'z-index': '1001',
                                    'line-height':'1.5em',
                                })
                                
                            }
                });
            }

            if (fileSize / 1024 / 1024 >= 300) {
                Toast({ 
                    message: '视频大小有误，请上传300M以内的视频。',
                    position: 'center',
                    duration: 2000
                });
                this.$refs.vExampleFile.files[0] = null
                return
            }
            // setTimeout(()=>{
            //     if (Number(self.videoDuration) < 60 || Number(self.videoDuration)>180) {
            //         console.log('Number(self.videoDuration)',Number(self.videoDuration));
            //             Toast({ 
            //             message: '视频长度有误，请上传1-3分钟内的视频',
            //             position: 'center',
            //             duration: 2000
            //         });
            //         return;
            //     }
            // },800);
            this.tcVod =new TcVod({
                getSignature: self.getSignature // 前文中所述的获取上传签名的函数
            })
            var hh = this.$refs.vExampleFile.files[0];
            var uploader=this.tcVod.upload({
              mediaFile: hh,
            })
           
            uploader.on('media_progress', function (info) {
                uploaderInfo.progress = info.percent;
                var percent = Math.floor(uploaderInfo.progress * 100) + '%';
                $('.fill').css('width',percent);
            })
          
          
            uploader.on('media_upload', function (info) {
              uploaderInfo.isVideoUploadSuccess = true;
            })
            var uploaderInfo = {
              videoInfo: uploader.videoInfo,
              isVideoUploadSuccess: false,
              isVideoUploadCancel: false,
              progress: 0,
              fileId: '',
              videoUrl: '',
              cancel: function() {
                uploaderInfo.isVideoUploadCancel = true;
                var percent = Math.floor(uploaderInfo.progress * 100) + '%';
                $('.fill').css('width',percent);
                
                uploader.cancel();
             
              },
              
            }
            this.uploaderInfos.push(uploaderInfo);
            self.isUpload='1';
            uploader.done().then(function(doneResult) {
              uploaderInfo.fileId = doneResult.fileId;
              uploaderInfo.videoUrl=doneResult.video.url;
              self.isfileId=doneResult.fileId;
              self.isvideoUrl=doneResult.video.url;
              self.isUpload='';
              $('.addVideo').hide();
              $('.isVideo').show();
            
              self.cbct.setCookie('isfileId', escape(self.isfileId));    
              self.cbct.setCookie('isvideoUrl',escape(self.isvideoUrl));  
            }).catch(function (err) {
                self.isUpload='';  
                Toast({ 
                    message: '上传失败,请重新上传啊',
                    position: 'center',
                    duration: 2000
                });  
                self.$refs.vExample.reset();
                self.uploaderInfos=[];   
                if(self.player != ''){
                    self.player.destroy();
                }       

             })
        },
        toPercent:function(data){
            return Math.floor(data * 100) + '%'
        },
        // 选择地区
        changeCity:function(picker, values){
            let self =this;
            if (self.flag) {
                picker.setSlotValues(1,values[0].city);
                self.tempCity=values[1].name;
            }else{
                self.flag=true;
            }
        },
        // 打开选择地区
        toSelectCity:function(){
            this.popupVisible = true;
            this.flag=true;
            $('html').css('position','fixed');
            $('html').css('top','0');
            $('html').css('bottom','0');
        },
        //取消选择地区
        cancel:function(){
            this.popupVisible = false;
            $('html').css('position','static');
        },
        //保存所选地区
        save:function(){
            this.popupVisible = false;
            this.cityname=this.tempCity;
            $('html').css('position','static');
        },
        //获取城市列表
        getCity:function(){
            let self = this;
            self.api2.post(self.cbct.https()+'/v2/ncp/city-list').then((response)=>{
                if(response.c == this.cbct.code.successRes){  
                   this.areaList[0].values=response.d;
                }else if(response.c == '484'){
                       Toast({ 
                            message: response.m,
                            position: 'center',
                            duration: 1000
                        });

                }else if(response.c == this.cbct.code.noLogin){
                        Toast({ 
                            message: '服务器开小差，请稍后重试',
                            position: 'center',
                            duration: 1000
                        });
                
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                      Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                }else{
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                }
            }
            ).catch((error)=>{console.log(error);})


        },
           //安卓title
       getTitle:function(){
            var self=this;
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var obj={
                "action": "setTitle",
                "content": {
                    'title':'上传祝福视频',
                }
            }
            if (isAndroid){
                App.onAppResponse(JSON.stringify(obj));
            }
        },
        addVideo:function(){
            var timestamp=new Date().getTime();
            let endTime = this.cbct.getCookie('endTime') *1000;
            if (timestamp>endTime) {
                Toast({
                        message: '活动已结束，其他视频和个人视频可正常点击查看',
                        position: 'center',
                        duration: 1000
                });
            }else{
                let self = this;
                setTimeout(function(){ 
                    self.isDisabled = false;
                },3000);
                self.api2.post(self.cbct.https()+'/v2/ncp/upload', this.qs.stringify({
                    url:self.isvideoUrl,
                    file_id:self.isfileId,
                    title:self.vdNmae,
                    type:'1',
                    city_name:'其他'
                })).then((response)=>{
                    if(response.c == this.cbct.code.successRes){  
                        if (response.d.status=='1') {
                            self.ncp_id=response.d.ncp_id;
                            self.isLogin();
                            
                        }else{
                            Toast({ 
                                message: '上传失败',
                                position: 'center',
                                duration: 1000
                            });
                        }
                                
                    }else if(response.c == '484'){
                            Toast({ 
                                message: response.m,
                                position: 'center',
                                duration: 1000
                            });

                    }else if(response.c == this.cbct.code.noLogin){
                            Toast({ 
                                message: '服务器开小差，请稍后重试',
                                position: 'center',
                                duration: 1000
                            });
                    
                        timing.time();
                    }else if(response.c == this.cbct.code.raleNoLogin){
                            Toast({
                            message: '服务器开小差，请稍后重试',
                            position: 'center',
                            duration: 1000
                        });
                        
                    }else{
                        Toast({
                            message: '服务器开小差，请稍后重试',
                            position: 'center',
                            duration: 1000
                        });
                    }
                }
                ).catch((error)=>{console.log(error);})

                }
        },
         // 嵌入app获取用户登陆状态
        onWebResponse:function(str) {
            var obj=JSON.parse(str);
            var action=obj.action;
            var self=this;
            var content=obj.content;
            if (action=='setUserInfo') {
                self.did=content.did;
                self.isToken=content.token;
                self.isSalt=content.salt;
                if (self.isSalt=='') {
                    self.cbct.setCookie('salt2','SALT'); 
                }else{
                    self.cbct.setCookie('salt2',self.isSalt);
                }
                if (self.isToken=='') {
                    self.cbct.setCookie('token2','TOKEN'); 
                }else if(self.isToken!='' && self.cbct.getCookie('isReturn') == '1' && self.cbct.getCookie('ncpId') != ''){
                    self.cbct.setCookie('token2',self.isToken);
                    self.appAction();
                    self.$router.replace({
                        path:'newYearVideoPage?from1=app',
                    })   
                }else{
                    self.cbct.setCookie('token2',self.isToken);
                }
                if(self.did==''){
                   self.cbct.setCookie('did',self.did);
                }
            }
            else if(action=='onUploadVideoSuccess'){
                self.cbct.setCookie('isfileId', escape(content.videoId));    
                self.cbct.setCookie('isvideoUrl',escape(content.videoUrl));  
                var url1=content.videoUrl;
                if (url1 !='') {
                    var str ='';
                    str += '<div id="id_test_video" class="id_test_vide swiper-slide" style="width:4.12rem;height:auto">'
                    str += '</div>';
                    $('.isVideo .swiper-wrapper #id_test_video').remove();
                    $('.isVideo .swiper-wrapper').append(str);
                }
                if(this.player == ''){
                    this.player = new TcPlayer('id_test_video', {
                             mp4: url1,
                            "autoplay" : false,      //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                            "width" :  '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                            "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                            flashUrl:'//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf',
                            systemFullscreen:true,
                            "wording": {
                                2032: "请求视频失败，请检查网络",
                                2048: "请求m3u8文件失败，可能是网络错误或者跨域问题"
                            },
                            // 'controls':'none',
                            h5_flv:true,
                            poster:self.cbct.imgUrlImg()+self.cbct.getCookie('image'),
                            x5_player:true,
                            x5_type:'h5',
                            x5_fullscreen:'true',
                            flash:true,
                            live:false,
                            x5_orientation:2,
                            listener:function(){
                                // $('video').css('object-fit','fill');
                                var u = navigator.userAgent, app = navigator.appVersion;
                                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                                //解决问题的代码
                                if(isAndroid){
                                    $('video').attr("x5-video-player-type","h5-page");
                                }
                                var heightsss = $('.vcp-timelabel').height();
                                $('.vcp-timelabel').css({
                                    'font-size': '0.26rem',
                                    'font-weight': 'normal',
                                    'line-height':heightsss+'px',
                                });  
                                $('.vcp-slider-thumb').css({
                                    'background': 'rgba(204, 50, 50, 1) !important',
                                })
                                $('.vcp-slider-track').css({
                                    'background': 'rgba(204, 50, 50, 1) !important',
                                })
                                
                                $('.vcp-slider').css({
                                    'background': 'rgba(255, 255, 255, 0.3)',
                                })
                                var height222 = (heightsss/2) - 3;
                                $('.vcp-timeline').css({
                                    'height': '2px',
                                    'margin-left': '49%',
                                    'width': '35%',
                                    'margin-top': height222+'px',
                                    'top':'0',
                                    'left': '0',
                                    'height': '10px',
                                    'position': 'absolute',
                                    'z-index': '1001',
                                    'line-height':'1.5em',
                                })
                                
                            }
                   });
                }
                self.isfileId=content.videoId;
                self.isvideoUrl=content.videoUrl;
                $('.addVideo').hide();
                $('.isVideo').show();
            }
        },
            // app获取到视频id关联用户
        appAction:function(){
            var self = this;
            this.api2.post(this.cbct.https()+'/v2/ncp/bin-ding', this.qs.stringify({
                ncp_id:self.cbct.getCookie('ncpId'),
            })).then((response)=>{
                if(response.c == this.cbct.code.successRes){  
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                }else{
                    Toast({
                        message: '服务器开小差，请稍后重试',
                        position: 'center',
                        duration: 1000
                    });
                }
                
            }
            ).catch((error)=>{console.log(error);})
        }, 

        isLogin:function(){
            var self =this;
            if (self.cbct.getCookie('token2')=='TOKEN') {
                self.gotoLogin=true;
                self.isReturn='1';
                self.cbct.setCookie('isReturn','1');    
            }else{
                if (self.from1 == 'app') {
                    Toast({ 
                        message: '视频上传成功审核中……',
                        position: 'center',
                        duration: 2000
                    });
                    self.$router.replace({
                        path:'newYearmyVideo?from1=app&noShow=1',
                    })   
                }else{
                    Toast({ 
                        message: '视频上传成功审核中……',
                        position: 'center',
                        duration: 2000
                    });
                    self.$router.replace({
                        path:'newYearmyVideo?noShow=1',
                    })   
                }
            }
        },
        stop:function(){
            this.stops = '1';
            $('video')[0].pause()
        },
        //全屏
        bigs:function(){
            $('video')[0].webkitRequestFullScreen();
        },

        gotoLoginPage:function(){
            var self=this;
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (self.from1 == 'app') {
                    self.cbct.setCookie('ncpId',self.ncp_id);  
                    const win = window;
                    var obj={
                        "action": "goToLogin",
                        "content": {
                            'isReturnHomepage':'0'
                        }
                    }
                    if (isAndroid) {
                        App.onAppResponse(JSON.stringify(obj));

                    }
                    if (isIOS) {
                        win.webkit.messageHandlers.onAppResponse.postMessage(JSON.stringify(obj));
                    }  
            }else{
                self.cbct.setCookie('ncpId',self.ncp_id); 
                self.$router.push({path:'./nearYearLogin?ncp_id='+this.ncp_id });
            }
        },
    },
    mounted(){
        document.body.style.background="rgba(255, 244, 221, 1)";
        var src = this.cbct.https().split('channels-')[1].split('.')[0];
        if(src != ''&& src != undefined){
            if(src != 'dev' && src != 'test'){
                src = '';
            }else{
                src = src+'.';
            }
        }
        this.loginUrl = 'http://channels.h5.'+src+'cbct.cn/newYearVideoPage',
        share.share(this.loginUrl,'听见广播 云贺新春','全国电台陪您一起过新年','http://img001.seefm.com.cn/image/newYearShare.jpg');
        share.QQshare(this.loginUrl,'听见广播 云贺新春','全国电台陪您一起过新年','http://img001.seefm.com.cn/image/newYearShare.jpg');
        var that=this;
        window['onWebResponse']=(str)=>{
            that.onWebResponse(str)
        }

    },
    created(){
        this.from1=this.$route.query.from1;
        $('title').html("上传祝福视频");
        this.getCity();
        if (this.cbct.getCookie('isReturn') !='') {
            this.cbct.clearOneCookie('isReturn');
        };
        if (this.from1=='app') {
            this.getTitle();
            this.broadcast();
        }
    },
    destroyed(){
        if(this.player != ''){
            this.player.destroy();
        }
    },

    watch:{
        popupVisible:{
            handler(val){
                if (val) {
                    setTimeout(()=>{
                        this.$set(this.areaList[0],'defaultIndex',0);
                    },100)
                }else{
                    this.$set(this.areaList[0],'defaultIndex',1);
                }
            }
        },
        vdNmae:{
            handler:function(newVal,oldVal){
             var reg =/^[\u4e00-\u9fa5_a-zA-Z0-9\s\·\~\！\@\#\￥\%\……\&\*\（\）\——\-\+\=\【\】\{\}\、\|\；\‘\’\：\“\”\《\》\？\，\。\、\`\~\!\#\$\%\^\&\*\(\)\_\[\]{\}\\\|\;\'\'\:\"\"\,\.\/\<\>\?]+$/;
             if (newVal !='') {
                 if(!reg.test(newVal)){
                 this.vdNmae= oldVal;
              }
             }
             
            }
          }
    }
}
</script>
<style>
.uploadVadio .vcp-timelabel{
    line-height: 1rem !important;
    padding: 0;
}
.vcp-panel-bg{
        background: none !important;
}
.vcp-panel-bg{
        background: -moz-linear-gradient(top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%);
        background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(0,0,0,0.7)), color-stop(100%,rgba(0,0,0,0)));
        background: -webkit-linear-gradient(top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0) 100%);
        background: -o-linear-gradient(top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0) 100%);
        background: -ms-linear-gradient(top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0) 100%);
        background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0) 100%);
}
.uploadVadio .vcp-playtoggle{
    width: 1.5em;
    background-repeat: no-repeat;
    background-position: 100% center;
}

.uploadVadio .vcp-fullscreen-toggle{
    width: 1.5em;
    background-repeat: no-repeat;
    background-position: 100% center;

}
.uploadVadio .vcp-timeline{
    margin-left: 55% !important;
    width: 30% !important;
}



</style>

<style scoped lang="scss">
.uploadVadio{
    width: 100%;
    min-height: 100%;
    overflow: hidden;
    box-sizing: border-box;
   
    .vadioContainer{
        width: 100%;
        box-sizing: border-box;
        font-size: 0.28rem; 
         .mint-popup {
             width: 100%;
         }
         .leftFonts{
             font-weight:500;
             color:rgba(51,51,51,1);
             font-size:0.28rem;
         }
         .pop-btn{
             display: flex;
             box-sizing: border-box;
             align-items: center;
             justify-content: space-between;
             border-bottom: solid 1px #eaeaea;
             height: 0.8rem;
             line-height: 0.8rem;
             p{
                width: 50%;
                text-align: center;
             }
         }
      
        .cityAndname{
            width: 100%;
            box-sizing: border-box;
            font-size:0.28rem;
            padding: 0 0.44rem;
            font-weight:500;
            .isCity{
                display: flex;
                align-items: center;
                margin: 0.26rem 0 0.67rem;
                justify-content: space-between;
                img{
                    width: 0.4rem;
                }
                .toCity{
                    display: flex;
                    align-items: center;
                    font-size: 0.28rem;
                    font-weight:500;
                    color:rgba(51,51,51,1);
                }
              
     
               

            }
            .videoName{
                display: flex;
                align-items: center;
                height: auto;
                border-bottom: solid 1px #E6E6E6;
                textarea{
                    padding-top: 0.66rem;
                    width: 60%;
                    border: none;
                    outline: none;
                    background:rgba(255, 244, 221, 1);
                    padding-left: 0.1rem;   
                    line-height: 0.45rem;
                    padding-left: 0.52rem;
                    font-size:0.28rem;
                    font-weight:500;
                    color:  rgba(168, 31, 31, 1);
                }
                p{
                    color:rgba(221,221,221,1);
                }
                p.changcolor{
                    font-weight:400;
                    color:rgba(255,118,99,1);
                    font-size: 0.3rem;
                }
                textarea::-webkit-input-placeholder {
                  font-weight:400;
                  color:rgba(0,0,0,.3);
                  font-size:0.24rem;
                }

                img{
                    width: 0.13rem;
                }
               
            }
            .realUpload{
                margin-top: 0.4rem;
                text-align: left;
            }
            .realVideo{
               
                .addVideo{
                    width:4.12rem;
                    height:2.32rem;
                    background:rgba(255, 197, 170, 1);
                    border-radius:0.08rem;
                    margin: 0.44rem auto 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 0.4rem;
                    }
                }
                .isVideo{
                    width:4.12rem;
                    height:2.32rem;
                    margin: 0.44rem auto 0;
                    display: none;
                    position: relative;
                    border-radius:0.08rem;
                    .video{
                        width:4.12rem;
                        height:2.32rem;
                        box-sizing: border-box;
                        border-radius:0.08rem;
                    }
                    .swiper-wrapper{
                        .id_test_video{
                            width: 100%;
                        }
                        
                    }
                    .cengs{
                        width: 4.14rem;
                        height: 2.33rem;
                        // background: #666;
                        background-size: 100%;
                        border-radius:0.08rem;
                    }
                    // video{
                    //     width: 100%;
                    //     height: 100%;
                    // }
                    .img1{
                        width: 0.4rem;
                        position: absolute;
                        right: -0.2rem;
                        top: -0.2rem;
                        z-index: 100;
                    }
                    
                }

            }
            .tipsFonts{
                margin-top: 0.46rem;
                font-weight:400;
                color:rgba(102,102,102,1);
                font-size:0.24rem;
                line-height: 1.5;
                p{
                    margin-bottom: 0.08rem;
                }

            }
            .button1{
                margin: 1.82rem auto 0rem;
                .red{
                   width: 4.06rem;
                   text-align: center;
                   margin: auto;
                   button{
                       width: 100%;
                       height: 0.88rem;
                       border: none;
                       border: 0;
                       background-color: transparent;
                       outline: none;
                       font-weight:500;
                       color:rgba(255,255,255,1);
                       font-size: 0.32rem;
                   }
                   .button11{
                      background:url('../../assets/img/wuhanImg/button2.png') no-repeat;
                      background-size: 4.06rem 0.96rem;
                      background-position: center center;
                   }
                   .button22{
                      background:url('../../assets/img/wuhanImg/button1.png') no-repeat;
                      background-size: 4.06rem 0.96rem;
                      background-position: center center;
                   }
                   
                    img{
                        width: 100%;
                    }
                }
            }
          
        }
        .tips{
            text-align: left;
            margin-top: 0.07rem;
            font-weight:400;
            color:rgba(255,118,99,1);
        }
        .isTan{
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.7);
            z-index: 22;
            .tips1{
                position: fixed;
                top:20%;
                left: 0.65rem;
                width:6.2rem;
                height:2.52rem;
                background:rgba(255,255,255,1);
                border-radius:0.16rem;
                margin: 30% auto 0;
                .tipstitle{
                    font-size:0.28rem;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    padding-top: .6rem;
                    margin-bottom: 0.4rem;
                }
                .hideshow{
                    .show{
                        display: inline-block;
                        width:1.6rem;
                        height:0.68rem;
                        border-radius:0.54rem;
                        border:solid 1px rgba(204,50,50,1);
                        font-size:0.28rem;
                        font-weight:400;
                        color:#CC3232;
                        line-height:0.71rem;
                        text-align: center;
                    }
                    .hide{
                        color:rgba(102,102,102,1);
                        border: solid 1px #666;
                        margin-left: 1rem;  
                    }
                }
               
            }

        }

    }
     // 进度条遮罩
    .mark{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.7);
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;
        pointer-event:none;
        .uploaderMsgBox{
            font-size: 0.28rem;
            position: relative;
            .progressBar{
                width: 6.2rem;
                height: 0.02rem;
                border: solid 1px rgba(221,221,221,1);
                position: relative;
                background:rgba(221,221,221,1);
                .fill{
                    position: absolute;
                    top: -1px;
                    left: -1px;
                    width: 0;
                    height: 0.02rem;
                    border: solid 1px rgba(184,40,40,1);
                    background:rgba(184,40,40,1);
                }

            }
    
        }
        .goLogin{
            width: 6rem;
            .img1{
                width: 6rem;
                height: 4.04rem;
                box-sizing: border-box;
                padding-top: 2.16rem;
                background:url('../../assets/img/wuhanImg/gotoLogin.png') no-repeat;
                background-size: 6rem 4.04rem;
                background-position: center center;
                .top{
                    font-size:0.34rem;
                    font-weight:600;
                    color:rgba(159,52,36,1);
                    margin-bottom: 0.38rem;
                }
                .top2{
                    font-weight:400;
                    color:rgba(159,52,36,1);
                    font-size:0.32rem;
                }
              
            }
            .fonts{
                height:1.04rem;
                line-height: 1.04rem;
                background:rgba(255,255,255,1);
                border-radius:0rem 0rem 0.16rem 0.16rem;
                font-weight:500;
                color:rgba(68,115,225,1);
                font-size:0.32rem;
            }
            

        }
        
    }
    .mark1{

    }

}

    
</style>
